import { user } from "../types";


export const getUserProfile = () => ({ type: user.USER_PROFILE_REQUEST });


export const getCityFromPincode = (pincode, index) => ({
	type: user.GET_CITY_FROM_PINCODE_REQUEST,
	payload: { pincode, index },
});

export const gstValidation = (gst_number, customer_id) => ({
	type: user.GST_VALIDATION_REQUEST,
	payload: { gst_number, customerId: customer_id }
});

export const getAllCities = () => ({ type: user.CITIES_LIST_REQUEST });